module.exports = __webpack_public_path__ + "img/bg7.f0f74da.png";